import common from "../../utill/Common";
import axios from "axios";

class CommercialService {
  add = async (
    token,

    bank_name,
    account_name,
    account_number,
    upi_id,
    ifsc_code,
    branch_name,
    status
  ) => {
    const url = common.baseUrl + "admin/bank_master/add";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        bank_name,
        account_name,
        account_number,
        upi_id,
        ifsc_code,
        branch_name,
        status,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  update = async (
    token,
    id,
    bank_name,
    account_name,
    account_number,
    upi_id,
    ifsc_code,
    branch_name,
    status
  ) => {
    const url = common.baseUrl + "admin/bank_master/update";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        id,
        bank_name,
        account_name,
        account_number,
        upi_id,
        ifsc_code,
        branch_name,
        status,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  fetchByID = async (token, id) => {
    const url = common.baseUrl + "admin/bank_master/fetch_by_id";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ id }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  fetchAll = async (token) => {
    const url = common.baseUrl + "admin/bank_master/fetch_all";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: null,
    };

    const response = await fetch(url, options);

    return response.json();
  };

  delete = async (token, id) => {
    const url = common.baseUrl + "admin/bank_master/delete";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ id }),
    };

    const response = await fetch(url, options);

    return response.json();
  };
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new CommercialService();
